module.exports = window["MaterialUI"].AppBar;